<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>

<div class="container">
    <div class="row">
        <div class="col-sm-6">
            <h1 class="title-default">Fabricantes</h1>
        </div>
    </div>
    <form class="form" [formGroup]="model" (ngSubmit)="clickPesquisar()" class="search-area">
        <div class="row">
            <div class="col-md-6">
                <mat-form-field appearance="outline">
                    <mat-label>Nome fabricante</mat-label>
                    <input matInput formControlName="nomeFabricante" type="text">
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <button type="submit" mat-button class="btn-secundary" style="width: 140px;">
                    Pesquisar
                </button>
            </div>
        </div>
    </form>

    @if(this._listaFabricanteResponse && this._listaFabricanteResponse.listaFabricante.length > 0){
        <table mat-table [dataSource]="_dataSource">
          <ng-container matColumnDef="idFabricante">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> # </th>
              <td mat-cell *matCellDef="let element"> {{element.idFabricante}} </td>
          </ng-container>

          <ng-container matColumnDef="nomeFabricante">
            <th mat-header-cell *matHeaderCellDef> Nome fabricante </th>
            <td mat-cell *matCellDef="let element"> {{element.nomeFabricante}} </td>
          </ng-container>

          <ng-container matColumnDef="versao">
              <th mat-header-cell *matHeaderCellDef> Versão </th>
              <td mat-cell *matCellDef="let element"> {{element.versao}} </td>
          </ng-container>

          <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef> Status </th>
              <td mat-cell *matCellDef="let element"> {{element.status}} </td>
          </ng-container>

          <ng-container matColumnDef="datetimeInclusao">
            <th mat-header-cell *matHeaderCellDef> Data/Hora </th>
            <td mat-cell *matCellDef="let element">
              {{ formatDatetimeInclusao(element) }}
            </td>
          </ng-container>

          <ng-container matColumnDef="usuarioAdmin">
            <th mat-header-cell *matHeaderCellDef> Usuário </th>
            <td mat-cell *matCellDef="let element"> {{element.usuarioAdmin}} </td>
          </ng-container>

          <ng-container matColumnDef="action-edit">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                  <a mat-mini-fab aria-label="Editar" class="fab-action default" [routerLink]="['/tintas/fabricante/cadastrar', {idFabricante: element.idFabricante}]" *appTemPermissao="_PermissaoEnum.RepositorioTintas_Fabricante_Alterar">
                      <mat-icon>edit</mat-icon>
                  </a>
              </td>
          </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div class="col-12 text-center ver-mais-pesquisa">
            <button type="button" mat-button class="btn-primary" [disabled]="_ultimaPagina" (click)="proximaPagina()">
                @if (_isLoading === true) {
                    <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
                @else{
                    <span class="material-symbols-outlined">keyboard_arrow_down</span>
                    Ver mais
                }
            </button>
        </div>
    }@else if(_isLoading === true){
        <table>
            @for (item of [1,2,3]; track item) {
                <tr>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'110'" [marginTop]="'30'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'220'" [marginTop]="'30'" [marginLeft]="'50'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'320'" [marginTop]="'30'"  [marginLeft]="'50'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'40'" [marginTop]="'30'"  [marginLeft]="'100'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'40'" [marginTop]="'30'"  [marginLeft]="'20'"></app-loading-box>
                    </td>
                </tr>
            }

        </table>
    }
    @else if(this._listaFabricanteResponse?.listaFabricante?.length === 0){
        <app-empty-list [title]="'Não foi encontrado nenhum fabricante com o filtro informado'"></app-empty-list>
    }



</div>
